import { createContext } from 'react';
import { ContextValue } from './types';

const defaultValue = { setActions: () => {}, setOnGoBack: () => {} };
export const context = createContext<ContextValue>(defaultValue);
export const { Provider } = context;
